export enum ApprovalModalResult {
  Cancel = 0,
  Approve = 1,
}



// WEBPACK FOOTER //
// ./src/app/common/approval-modal/approval-modal-result.enum.ts